/**
 * @fileoverview Reporting Phase (MOR-556, Phase B)
 *
 * URL: /dashboard/jobs/:jobId/reporting
 *
 * Manage and generate reports on the job. The user picks a firm report
 * template; Morgan's app-orchestrated multi-agent flow drafts each section from
 * the job's already-extracted data; the user reviews, edits, and exports.
 */

import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { ReportingView } from "@/components/jobs/phases/reporting/ReportingView";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/reporting",
)({
  component: ReportingPhase,
  // `report` selects a specific report (deep-linked from the sidebar's
  // Reporting group, MOR-917).
  validateSearch: (search: Record<string, unknown>): { report?: string } => ({
    report: typeof search.report === "string" ? search.report : undefined,
  }),
  beforeLoad: () => ({
    title: "Reporting",
  }),
});

function ReportingPhase() {
  const { jobId } = Route.useParams();
  return <ReportingView jobId={jobId as Id<"jobs">} />;
}
